import { type ReactNode } from "react";

type Column<T> = { header: string; render: (row: T) => ReactNode };

export function DataTable<T>({
  rows,
  columns,
  empty,
  loading,
  error,
}: {
  rows: T[] | null;
  columns: Column<T>[];
  empty: string;
  loading?: boolean;
  error?: string | null;
}) {
  if (loading) {
    return <p className="mt-4 text-slate-500">…</p>;
  }
  if (error) {
    return <p className="mt-4 text-red-600">{error}</p>;
  }
  if (!rows || rows.length === 0) {
    return <p className="mt-4 text-slate-500">{empty}</p>;
  }
  return (
    <div className="mt-4 overflow-x-auto rounded-md border border-slate-200 bg-white">
      <table className="min-w-full divide-y divide-slate-200 text-sm">
        <thead className="bg-slate-50 text-slate-700">
          <tr>
            {columns.map((c, i) => (
              <th key={i} className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wide">
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((row, i) => (
            <tr key={i} className="hover:bg-slate-50">
              {columns.map((c, j) => (
                <td key={j} className="px-4 py-3 text-slate-700">
                  {c.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
